import React from 'react';
import './ColoredList.scss';

export default function ColoredList({ content }) {
    return (
        <div
            className="workshop-colored_list">
            <h2>{content.Titre}</h2>
            <ol>
                {
                    content.Items.map((item, index) => (
                        <li key={index} style={{ backgroundColor: item.CouleurFondTexte, color: item.CouleurTexte }}>
                            <span>{item.Texte}</span>
                        </li>
                    ))
                }
            </ol>
        </div>
    )
}
